@if (showCountdown && countdownText !== '') {
  <span class="countdown-text">{{ countdownText }}</span>
}
